// @flow

import styled from 'styled-components';

export default styled.div`
  padding: 8rem 4rem 0 0;
  overflow: hidden;
  width: 100%;
  height: 100vh;
  margin: 0;
  box-sizing: border-box;
  .content {
    overflow: hidden;
  }
  .loading {
    color: #fff;
    direction: ltr; 
    text-align: right;
  }
`;
